import { useState, useEffect } from "react";

const getWidth = () =>
  window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

const getHeight = () =>
  window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

export function useCurrentSize() {
  const [size, setSize] = useState({ width: getWidth(), height: getHeight() });

  useEffect(() => {
    // timeoutId for debounce mechanism
    let timeoutId = null;
    const resizeListener = () => {
      // prevent execution of previous setTimeout
      clearTimeout(timeoutId);
      // change width from the state object after 150 milliseconds
      timeoutId = setTimeout(() => {
        setSize({ width: getWidth(), height: getHeight() });
      }, 150);
    };

    window.addEventListener("resize", resizeListener);

    // clean up function
    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, []);

  return size;
}
